import { Box, Stack, Typography } from "@mui/material";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis";
import type { WorkbookFilter, WorkbookReportParameter } from "../../../../../../api/types/workbookRuns.types";
import { getFilterModelTypeLabel, ReportSource } from "../../../../../../api/types/workbookRuns.types";
import ConditionBlockValue from "./ConditionBlockValue";

interface ConditionBlockProps {
  filters: WorkbookReportParameter[];
  workbookFilters: WorkbookFilter[];
  reportId: string;
}

function ConditionBlock({ filters, workbookFilters, reportId }: ConditionBlockProps) {
  return (
    <Stack className="condition-block" sx={{ width: "100%" }}>
      <Typography variant="subtitle2" sx={{ mt: 1, mb: 0.1 }}>
        Conditions
      </Typography>
      {filters.map((filter) => {
        //An operator on its own says nothing, so it only appears next to the values it applies to.
        const equalityLabel =
          filter.values.length > 0 ? getFilterModelTypeLabel(filter.equalityType, filter.type) : undefined;
        const name = getFilterName(filter) + (equalityLabel ? `(${equalityLabel})` : "");
        return (
          <Box
            key={filter.id}
            sx={{
              display: "grid",
              gridTemplateColumns: "5fr 7fr",
              gridTemplateRows: "1fr",
              gridColumnGap: 4,
              alignItems: "flex-start",
            }}
          >
            <TypographyTooltipEllipsis
              text={name}
              typographyProps={{
                variant: "caption",
                color: "secondary",
              }}
            />
            <Box sx={{ display: "flex", alignItems: "flex-start", minWidth: 0, gap: 0.5 }}>
              <ConditionBlockValue filter={filter} reportId={reportId} workbookFilters={workbookFilters} />
            </Box>
          </Box>
        );
      })}
    </Stack>
  );
}

export default ConditionBlock;

const getFilterName = (filter: WorkbookReportParameter) => {
  return (filter.reportSource === ReportSource.BI ? filter.description : filter.description || filter.name) ?? "";
};
